export default {
  selectors: {
    navAppStoreUrl: ({ app: { navAppStoreUrl } }) => navAppStoreUrl,
  },
};
